module.exports = __webpack_public_path__ + "img/quero-cobrar.9c3699be.png";